export const showComposeEditor = () => ({
  key: 'communicator',
  properties: {
    action: 'show communicator',
    type: 'composition'
  }
});